import { FavoriteRecreationResponse } from '@/types';
import { Api } from './api';

export const fetchFavoriteRecreations = async (
  recreationIds: number[]
): Promise<FavoriteRecreationResponse[]> => {
  const response = await Api.get<FavoriteRecreationResponse[]>(
    `favorite_recreations`,
    'customer',
    { recreationIds: recreationIds.join(',') }
  );
  return response.data;
};
